<app-action-item borderColor="var(--shade-2-color)" titleColor="#000000" backgroundColor="var(--shade-2-color)"
color="#000000" titleDictionaryKey="dd.appc_cfg_action_item.{{actionItem.id}}.name" [iconCSS]="actionItem?.iconCSS">
  <sc-flex [centered]="true" fitHeight>
    <div style="width: 100%; height: 100%;">
      <form [formGroup]="formGroup">
        <sc-string-field labelDictionaryKey="tmc-common.action-tablet.ui.lpr-action-item.numberplate" formControlName="numberPlate"></sc-string-field>
        <sc-content-spacer vertical></sc-content-spacer>
        <sc-flex centered>
          <sc-action-icon iconClass="fa-magnifying-glass fa-2x" (click)="handleNumberPlate()"></sc-action-icon>
        </sc-flex>
        <ng-container *ngIf="messageDictionaryKey">
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-dictionary-label [dictionaryKey]="messageDictionaryKey"></sc-dictionary-label>
        </ng-container>
      </form>
    </div>
  </sc-flex>
</app-action-item>
